import React from 'react'
import PropTypes from 'prop-types'
import Chip from '../ui/Chip'
import { getQuestionTypeLabel } from './questionTypeLabels'

const HEADER_CLASS = [
  'tw:flex tw:items-center tw:gap-2 tw:min-h-12',
  'tw:bg-white tw:border tw:rounded-t-lg! tw:py-3 tw:pl-3 tw:pr-1.5'
].join(' ')
const BODY_CLASS = 'tw:bg-white tw:border-x tw:border-b tw:rounded-b-lg! tw:p-4'

const QuestionCard = ({ question, errorMessages, headerAction, children }) => {
  const typeLabel = getQuestionTypeLabel(question)
  const borderClass = errorMessages.length ? 'tw:border-ds-danger!' : 'tw:border-gray-300'

  return (
    <div className={errorMessages.length ? 'is-invalid' : ''}>
      <div className={`${HEADER_CLASS} ${borderClass}`}>
        <span className="tw:text-sm tw:text-gray-950">{question.title}</span>
        {question.mandatory ? <span className="tw:text-ds-warning">*</span> : null}
        {typeLabel ? <Chip>{typeLabel}</Chip> : null}
        {headerAction ? <div className="tw:ml-auto">{headerAction}</div> : null}
      </div>
      <div className={`${BODY_CLASS} ${borderClass}`}>
        {children}
        {errorMessages.map((message, index) =>
          <div key={index} className="text-danger small tw:mt-1">{message}</div>)}
      </div>
    </div>
  )
}

QuestionCard.propTypes = {
  children: PropTypes.node,
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  headerAction: PropTypes.node,
  question: PropTypes.shape({
    context: PropTypes.string.isRequired,
    mandatory: PropTypes.bool,
    title: PropTypes.string
  }).isRequired
}

QuestionCard.defaultProps = {
  children: null,
  errorMessages: [],
  headerAction: null
}

export default QuestionCard
